export default {"src":"/_next/static/media/slide-security-icon.e63e7684.svg","height":77,"width":79};